import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { ageGenderDHIS2SRHReportHeader } from "../components/HeaderAttribute";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";
const AgeGenderDHIS2SRH = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branchName, setBranchName] = useState("");
  const [project, setProject] = useState("");
  const [bindProjectDD, setBindProjectDD] = useState([]);

  const [ageGenderFields, setAgeGenderFields] = useState({
    branchProject: "",
    sdp: "",
    area: "",
    serviceCategory: "",
    serviceSubCategory: "",
    servicesName: "",
  });
  const [ageGenderFieldsError, setAgeGenderFieldsError] = useState({
    sdpError: "",
    areaError: "",
    branchProjectError: "",

    serviceCategoryError: "",
    serviceSubCategoryError: "",
    servicesNameError: "",
  });

  const [showTable, setShowTable] = useState(false);

  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [getServicesData, setGetServicesDatas] = useState([]);
  const [getServiceSubCDatas, setGetServiceSubCDatas] = useState([]);
  const [bindServicesName, setBindServicesName] = useState([]);
  const [bindServiceSubCategory, setBindServiceSubCategory] = useState([]);
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindAgeGenderDHIS2SRHData, setBindAgeGenderDHIS2SRHData] = useState(
    []
  );
  const [bindServiceCategory, setBindServiceCategory] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);
  const [serviceCategoryNameList, setServiceCategoryNameList] = useState([]);
  const [serviceSubCategoryNameList, setServiceSubCategoryNameList] = useState(
    []
  );
  const [serviceNameList, setServiceNameList] = useState([]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      if (userProfileDatas[0]?.MstSDPId == null) {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: "",
        });
        setBranchName(userProfileDatas[0]?.LocationName_en);
      } else {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: [userProfileDatas[0]?.MstSDPId],
        });
        setBranchName(userProfileDatas[0]?.LocationName_en);
      }
    }
    BranchProjectFetchData();
    serviceCategoryDD();
    getProjectDDValues();
  }, [userProfileDatas ? userProfileDatas : undefined]);
  const getProjectDDValues = async () => {
    // Month Dropdown binding
    const response = await BindAPI("MasterDataAPI/BindProject");
    const getTnxProjectId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
            value: item.MstProjectId,
            label: item.ProjectName_en,
          }))
        : [];
    setBindProjectDD(getTnxProjectId);
  };
  const GoButton = async () => {
    const branchProjectValidate = ageGenderFields.branchProject
      ? ""
      : "Select Branch/Project";
    const sdpValidate = ageGenderFields.sdp ? "" : "Select SDP";

    const areaValidate = ageGenderFields.area ? "" : "Select Area";

    const serviceCategoryValidate = ageGenderFields.serviceCategory
      ? ""
      : "Select Service Category";
    const serviceSubCategoryValidate = ageGenderFields.serviceSubCategory
      ? ""
      : "Select Service Sub-Category";
    const servicesNameValidate = ageGenderFields.servicesName
      ? ""
      : "Select  Services";
    setAgeGenderFieldsError({
      ...ageGenderFieldsError,
      branchProjectError: branchProjectValidate,
      sdpError: sdpValidate,
      areaError: areaValidate,
      serviceCategoryError: serviceCategoryValidate,
      serviceSubCategoryError: serviceSubCategoryValidate,
      servicesNameError: servicesNameValidate,
    });

    let branchProjectArray = Array.from(
      { length: ageGenderFields.branchProject.length },
      (v, i) => ageGenderFields.branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    let sdpArray = Array.from(
      { length: ageGenderFields.sdp.length },
      (v, i) => ageGenderFields.sdp[i]
    );
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from(
      { length: ageGenderFields.area.length },
      (v, i) => ageGenderFields.area[i]
    );
    let areaResult = areaArray.join(",");

    let serviceCategoryArray = Array.from(
      { length: ageGenderFields.serviceCategory.length },
      (v, i) => ageGenderFields.serviceCategory[i]
    );
    let serviceCategoryResult = serviceCategoryArray.join(",");

    let serviceSubCategoryArray = Array.from(
      { length: ageGenderFields.serviceSubCategory.length },
      (v, i) => ageGenderFields.serviceSubCategory[i]
    );
    let serviceSubCategoryResult = serviceSubCategoryArray.join(",");

    let servicesArray = Array.from(
      { length: ageGenderFields.servicesName.length },
      (v, i) => ageGenderFields.servicesName[i]
    );
    let servicesResult = servicesArray.join(",");

    if (
      !branchProjectValidate &&
      !sdpValidate &&
      !areaValidate &&
      !serviceCategoryValidate &&
      !serviceSubCategoryValidate &&
      !servicesNameValidate
    ) {
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstServicesCategoryId: serviceCategoryResult,
          mstServicesSubCategoryId: serviceSubCategoryResult,
          mstServicesId: servicesResult,
          fromDate: fromDate,
          toDate: toDate,
          mstProjectId: project ? project : null,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "TXNServicesAPI/ReportAgeGenderDHIS2SRH"
      );

      setBindAgeGenderDHIS2SRHData(response.data.Table);
      setShowTable(true);
    } else {
    }
  };
  // const handleExport = () => {
  //   const dateRange = {
  //     fromDate: fromDate,
  //     toDate: toDate,
  //   };

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.toString(),
  //     areaData: areaNamesList.toString(),
  //     serviceCategoryData: serviceCategoryNameList.toString(),
  //     serviceSubCategoryData: serviceSubCategoryNameList.toString(),
  //     servicesData: serviceNameList.toString(),
  //   };

  //   exportData(
  //     ageGenderDHIS2SRHReportHeader.map((column) => column.title),
  //     bindAgeGenderDHIS2SRHData,
  //     dateRange,
  //     selectedOptionsData
  //   );
  // };

  const handleExport = async () => {
    const createdBy = sessionStorage.getItem("createdBy");
  
    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };
  
      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
        serviceCategoryData: serviceCategoryNameList.toString(),
        serviceSubCategoryData: serviceSubCategoryNameList.toString(),
        servicesData: serviceNameList.toString(),
      };
  
      
      if (!bindAgeGenderDHIS2SRHData || bindAgeGenderDHIS2SRHData.length === 0) {
        await IUDAPI(
          {
            mstUserId: parseInt(createdBy, 10),
            sp: "AGE GENDER DHIS2 SRH REPORT",
            action: "EXCEL EXPORT",
            status: "FAILED",
            tableName: null,
            description: "No data available to export",
          },
          "Log/IUDLog"
        );
  
        toast.error("No data available to export", {
          duration: 1000,
          position: "top-center",
        });
  
        return;
      }
  
      // ✅ SUCCESS LOG
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "SUCCESS",
          tableName: null,
          description: `Age Gender DHIS2 SRH Report Excel exported successfully. Total Records: ${bindAgeGenderDHIS2SRHData.length}`,
        },
        "Log/IUDLog"
      );
  
      // ✅ EXPORT
      exportData(
        ageGenderDHIS2SRHReportHeader.map((column) => column.title),
        bindAgeGenderDHIS2SRHData,
        dateRange,
        selectedOptionsData
      );
    } catch (error) {
      console.error("Export error", error);
  
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: "AGE GENDER  SRH REPORT",
          action: "EXCEL EXPORT",
          status: "FAILED",
          tableName: null,
          description: error?.message || "Excel export failed",
        },
        "Log/IUDLog"
      );
  
      toast.error("Failed to export Excel", {
        duration: 1500,
        position: "top-center",
      });
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      const NameList = ageGenderFields.branchProject
        .map(
          (option) =>
            bindBranchProjectDD?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setBranchProjectNamesList(NameList);
    }

    if (ageGenderFields.sdp) {
      const NameList = ageGenderFields.sdp
        .map((option) => bindSDP?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setSDPNamesList(NameList);
    }

    if (ageGenderFields.area) {
      const NameList = ageGenderFields.area
        .map((option) => bindArea?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setAreaNamesList(NameList);
    }

    if (ageGenderFields.serviceCategory) {
      const NameList = ageGenderFields.serviceCategory
        .map(
          (option) =>
            bindServiceCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceCategoryNameList(NameList);
    }

    if (ageGenderFields.serviceSubCategory) {
      const NameList = ageGenderFields.serviceSubCategory
        .map(
          (option) =>
            bindServiceSubCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceSubCategoryNameList(NameList);
    }

    if (ageGenderFields.servicesName) {
      const NameList = ageGenderFields.servicesName
        .map(
          (option) =>
            bindServicesName?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceNameList(NameList);
    }
  }, [ageGenderFields]);

  // const exportData = (columns, rows, dateRange, selectedDetails) => {
  //   // Title row configuration
  //   const titleRow = [
  //     {
  //       v: "Age&Gender - SRH",
  //       s: {
  //         font: { bold: true, sz: 16 },
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //   ];

  //   // Date range row with merged cells
  //   const dateRangeRow = [
  //     { v: "" },
  //     {
  //       v: "From Date:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: formatDate(dateRange.fromDate),
  //       s: {
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //     {
  //       v: "To Date:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //     {
  //       v: formatDate(dateRange.toDate),
  //       s: {
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //   ];
  //   // Branch information row with merged cells
  //   const branchRow = [
  //     { v: "" },

  //     {
  //       v: "Branch/Project:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.branchProjectData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "S.D.P.:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.sdpData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "Area:",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.areaData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },
  //   ];

  //   //Services information row with merged cells
  //   const servicesRow = [
  //     { v: "" },
  //     {
  //       v: "Service Category",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.serviceCategoryData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "Service Sub-Category",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.serviceSubCategoryData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },

  //     {
  //       v: "Services",
  //       s: {
  //         font: { bold: true },
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //     {
  //       v: selectedDetails.servicesData,
  //       s: {
  //         alignment: { horizontal: "left" },
  //         alignment: { wrapText: true }, // Enable text wrapping
  //       },
  //     },
  //   ];

  //   // Add empty row for spacing
  //   const spacingRow = [{ v: "" }];

  //   // Add "Total" column to headers
  //   const headerRow = [
  //     ...columns.map((column) => ({
  //       v: column,
  //       s: {
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         alignment: { horizontal: "left" },
  //       },
  //     })),
  //     {
  //       v: "Total",
  //       s: {
  //         fill: { fgColor: { rgb: "2D2D6E" } },
  //         font: { bold: true, color: { rgb: "FFFFFF" } },
  //         alignment: { horizontal: "left" },
  //       },
  //     },
  //   ];

  //   // Calculate column totals
  //   const columnTotals = {};
  //   const ageGroups = [
  //     "0to9",
  //     "10to14",
  //     "15to19",
  //     "20to24",
  //     "25to29",
  //     "30to34",
  //     "35to39",
  //     "40to44",
  //     "45to49",
  //     "50andAbove",
  //   ];

  //   // Initialize column totals
  //   ageGroups.forEach((ageGroup) => {
  //     columnTotals[`Female${ageGroup}`] = 0;
  //     columnTotals[`Male${ageGroup}`] = 0;
  //     columnTotals[`Other${ageGroup}`] = 0;
  //   });

  //   // Data rows with totals
  //   const dataRows = rows.map((rowData, index) => {
  //     const isAlternateRow = index % 2 === 1;
  //     const baseStyle = isAlternateRow
  //       ? { fill: { fgColor: { rgb: "F0F0F0" } } }
  //       : {};

  //     // Calculate row total
  //     let rowTotal = 0;
  //     ageGroups.forEach((ageGroup) => {
  //       rowTotal += Number(rowData[`FemaleAge${ageGroup}`] || 0);
  //       rowTotal += Number(rowData[`MaleAge${ageGroup}`] || 0);
  //       rowTotal += Number(rowData[`OtherAge${ageGroup}`] || 0);

  //       // Add to column totals
  //       columnTotals[`Female${ageGroup}`] += Number(
  //         rowData[`FemaleAge${ageGroup}`] || 0
  //       );
  //       columnTotals[`Male${ageGroup}`] += Number(
  //         rowData[`MaleAge${ageGroup}`] || 0
  //       );
  //       columnTotals[`Other${ageGroup}`] += Number(
  //         rowData[`OtherAge${ageGroup}`] || 0
  //       );
  //     });

  //     const formattedRow = [
  //       {
  //         v: index + 1,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },
  //       {
  //         v: rowData.Branch,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },
  //       {
  //         v: rowData.SDP_en,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },
  //       {
  //         v: rowData.AreaName_en,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },

  //       {
  //         v: rowData.Services_en,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },
  //       {
  //         v: rowData.ProjectName_en,
  //         s: { ...baseStyle, alignment: { horizontal: "left" } },
  //       },
  //       ...Object.entries(rowData)
  //         .filter(([key]) => key.match(/^(Female|Male|Other)Age\d+/))
  //         .map(([_, value]) => ({
  //           v: Number(value || 0),
  //           t: "n",
  //           s: {
  //             ...baseStyle,
  //             alignment: { horizontal: "right" },
  //             numFmt: "0",
  //           },
  //         })),
  //       // Add row total
  //       {
  //         v: rowTotal,
  //         t: "n",
  //         s: {
  //           ...baseStyle,
  //           font: { bold: true },
  //           alignment: { horizontal: "right" },
  //           numFmt: "0",
  //         },
  //       },
  //     ];

  //     return formattedRow;
  //   });

  //   // Create totals row
  //   const totalsRowStyle = {
  //     font: { bold: true },
  //     fill: { fgColor: { rgb: "E0E0E0" } },
  //     alignment: { horizontal: "left" },
  //   };

  //   const totalsRow = [
  //     { v: "", s: totalsRowStyle },
  //     { v: "", s: totalsRowStyle },
  //     { v: "", s: totalsRowStyle },
  //     { v: "", s: totalsRowStyle },
  //     { v: "", s: totalsRowStyle },
  //     { v: "Total", s: totalsRowStyle },

  //     ...Object.values(columnTotals).map((total) => ({
  //       v: total,
  //       t: "n",
  //       s: {
  //         ...totalsRowStyle,
  //         numFmt: "0",
  //         alignment: { horizontal: "right" },
  //       },
  //     })),
  //     // Add grand total
  //     {
  //       v: Object.values(columnTotals).reduce((sum, val) => sum + val, 0),
  //       t: "n",
  //       s: {
  //         ...totalsRowStyle,
  //         numFmt: "0",
  //         alignment: { horizontal: "right" },
  //       },
  //     },
  //   ];

  //   // Combine all rows
  //   const wsData = [
  //     titleRow,
  //     dateRangeRow,
  //     branchRow,
  //     servicesRow,
  //     spacingRow,
  //     headerRow,
  //     ...dataRows,
  //     totalsRow,
  //   ];
  //   const ws = XLSX.utils.aoa_to_sheet(wsData);

  //   // Set column widths
  //   const colWidths = [...columns, "Total"].map(() => ({ width: 25 }));
  //   ws["!cols"] = colWidths;

  //   ws["!rows"] = [
  //     { hpt: 30 }, // Title row height
  //     { hpt: 15 }, // Date range row height
  //     { hpt: 15 }, // Branch row height (taller for wrapped content)
  //     { hpt: 15 }, // Spacing row height
  //     { hpt: 15 }, // Header row height (taller for wrapped content)
  //     ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
  //     { hpt: 15 }, // Totals row height
  //   ];

  //   // Apply borders and styles
  //   const applyStyles = (ws) => {
  //     const range = XLSX.utils.decode_range(ws["!ref"]);
  //     for (let R = range.s.r; R <= range.e.r; R++) {
  //       for (let C = range.s.c; C <= range.e.c; C++) {
  //         const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
  //         if (!ws[cellRef]) continue;

  //         // Add borders to all cells
  //         ws[cellRef].s = {
  //           ...ws[cellRef].s,
  //           border: {
  //             top: { style: "thin", color: { rgb: "000000" } },
  //             bottom: { style: "thin", color: { rgb: "000000" } },
  //             left: { style: "thin", color: { rgb: "000000" } },
  //             right: { style: "thin", color: { rgb: "000000" } },
  //           },
  //         };
  //       }
  //     }
  //   };

  //   applyStyles(ws);

  //   // Create and save workbook
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  //   XLSX.writeFile(wb, "Age&Gender - SRH.xlsx");
  // };

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    const ageGroups = [
      "0to9",
      "10to14",
      "15to19",
      "20to24",
      "25to29",
      "30to34",
      "35to39",
      "40to44",
      "45to49",
      "50andAbove",
    ];
  
    /* ================= TITLE ROW ================= */
    const titleRow = [
      {
        v: "Age&Gender - SRH",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];
  
    /* ================= DATE ROW ================= */
    const dateRangeRow = [
      { v: "" },
      { v: "From Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.fromDate) },
      { v: "To Date:", s: { font: { bold: true } } },
      { v: formatDate(dateRange.toDate) },
    ];
  
    /* ================= FILTER ROWS ================= */
    const branchRow = [
      { v: "" },
      { v: "Branch/Project:", s: { font: { bold: true } } },
      { v: selectedDetails.branchProjectData },
      { v: "S.D.P.:", s: { font: { bold: true } } },
      { v: selectedDetails.sdpData },
      { v: "Area:", s: { font: { bold: true } } },
      { v: selectedDetails.areaData },
    ];
  
    const servicesRow = [
      { v: "" },
      { v: "Service Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceCategoryData },
      { v: "Service Sub-Category:", s: { font: { bold: true } } },
      { v: selectedDetails.serviceSubCategoryData },
      { v: "Services:", s: { font: { bold: true } } },
      { v: selectedDetails.servicesData },
    ];
  
    const spacingRow = [{ v: "" }];
  
    /* ================= HEADER ROW ================= */
    const staticHeaders = [
      "S.No",
      "Branch",
      "SDP",
      "Area",
      "Service",
      "Project",
    ];
  
    const dynamicHeaders = ageGroups.flatMap((age) => [
      `Female ${age}`,
      `Male ${age}`,
      `Other ${age}`,
    ]);
  
    const headerRow = [...staticHeaders, ...dynamicHeaders, "Total"].map(
      (col) => ({
        v: col,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "center" },
        },
      })
    );
  
    /* ================= COLUMN TOTALS INIT ================= */
    const columnTotals = {};
  
    ageGroups.forEach((age) => {
      columnTotals[`Female${age}`] = 0;
      columnTotals[`Male${age}`] = 0;
      columnTotals[`Other${age}`] = 0;
    });
  
    /* ================= DATA ROWS ================= */
    const dataRows = rows.map((rowData, index) => {
      const isAlternate = index % 2 === 1;
      const baseStyle = isAlternate
        ? { fill: { fgColor: { rgb: "F2F2F2" } } }
        : {};
  
      let rowTotal = 0;
  
      ageGroups.forEach((age) => {
        const female = Number(rowData[`FemaleAge${age}`] || 0);
        const male = Number(rowData[`MaleAge${age}`] || 0);
        const other = Number(rowData[`OtherAge${age}`] || 0);
  
        columnTotals[`Female${age}`] += female;
        columnTotals[`Male${age}`] += male;
        columnTotals[`Other${age}`] += other;
  
        rowTotal += female + male + other;
      });
  
      const row = [
        index + 1,
        rowData.Branch,
        rowData.SDP_en,
        rowData.AreaName_en,
        rowData.Services_en,
        rowData.ProjectName_en,
        ...ageGroups.flatMap((age) => [
          Number(rowData[`FemaleAge${age}`] || 0),
          Number(rowData[`MaleAge${age}`] || 0),
          Number(rowData[`OtherAge${age}`] || 0),
        ]),
        rowTotal,
      ];
  
      return row.map((cell) => ({
        v: cell,
        t: typeof cell === "number" ? "n" : "s",
        s: {
          ...baseStyle,
          alignment:
            typeof cell === "number"
              ? { horizontal: "right" }
              : { horizontal: "left" },
          numFmt: typeof cell === "number" ? "0" : undefined,
        },
      }));
    });
  
    /* ================= TOTAL ROW ================= */
    const totalsRowStyle = {
      font: { bold: true },
      fill: { fgColor: { rgb: "E0E0E0" } },
    };
  
    const totalsRow = [
      "",
      "",
      "",
      "",
      "",
      "Total",
      ...ageGroups.flatMap((age) => [
        columnTotals[`Female${age}`],
        columnTotals[`Male${age}`],
        columnTotals[`Other${age}`],
      ]),
      Object.values(columnTotals).reduce((sum, val) => sum + val, 0),
    ].map((cell) => ({
      v: cell,
      t: typeof cell === "number" ? "n" : "s",
      s: {
        ...totalsRowStyle,
        alignment:
          typeof cell === "number"
            ? { horizontal: "right" }
            : { horizontal: "left" },
        numFmt: typeof cell === "number" ? "0" : undefined,
      },
    }));
  
    /* ================= COMBINE ALL ROWS ================= */
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      servicesRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];
  
    const ws = XLSX.utils.aoa_to_sheet(wsData);
  
    /* ================= COLUMN WIDTHS ================= */
    ws["!cols"] = headerRow.map(() => ({ width: 18 }));
  
    /* ================= APPLY BORDERS ================= */
    const range = XLSX.utils.decode_range(ws["!ref"]);
    for (let R = range.s.r; R <= range.e.r; ++R) {
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
        if (!ws[cellRef]) continue;
  
        ws[cellRef].s = {
          ...ws[cellRef].s,
          border: {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          },
        };
      }
    }
  
    /* ================= SAVE FILE ================= */
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Age&Gender - SRH.xlsx");
  };
  

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = ageGenderDHIS2SRHReportHeader.map((column) => column.title);

    const data = bindAgeGenderDHIS2SRHData.map((rowData, index) => {
      return [
        index + 1,
        rowData.Services_en,
        rowData.FemaleAge0to9,
        rowData.MaleAge0to9,
        rowData.OtherAge0to9,
        rowData.FemaleAge10to14,
        rowData.MaleAge10to14,
        rowData.OtherAge10to14,
        rowData.FemaleAge15to19,
        rowData.MaleAge15to19,
        rowData.OtherAge15to19,
        rowData.FemaleAge20to24,
        rowData.MaleAge20to24,
        rowData.OtherAge20to24,
        rowData.FemaleAge25to29,
        rowData.MaleAge25to29,
        rowData.OtherAge25to29,
        rowData.FemaleAge30to34,
        rowData.MaleAge30to34,
        rowData.OtherAge30to34,
        rowData.FemaleAge35to39,
        rowData.MaleAge35to39,
        rowData.OtherAge35to39,
        rowData.FemaleAge40to44,
        rowData.MaleAge40to44,
        rowData.OtherAge40to44,
        rowData.FemaleAge45to49,
        rowData.MaleAge45to49,
        rowData.OtherAge45to49,
        rowData.FemaleAge50andAbove,
        rowData.MaleAge50andAbove,
        rowData.OtherAge50andAbove,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Age
        11: { cellWidth: "auto" }, // Gender
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Index column
        17: { cellWidth: "auto" }, // Auto adjust width
        18: { cellWidth: "auto" }, // Auto adjust width
        19: { cellWidth: "auto" }, // Auto adjust width
        20: { cellWidth: "auto" }, // Auto adjust width
        21: { cellWidth: "auto" }, // Auto adjust width
        22: { cellWidth: "auto" }, // Auto adjust width
        23: { cellWidth: "auto" }, // Auto adjust width
        24: { cellWidth: "auto" }, // Auto adjust width
        25: { cellWidth: "auto" }, // Auto adjust width
        26: { cellWidth: "auto" }, // Age
        27: { cellWidth: "auto" }, // Gender
        28: { cellWidth: "auto" }, // Auto adjust width
        29: { cellWidth: "auto" }, // Auto adjust width
        30: { cellWidth: "auto" }, // Auto adjust width
        31: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Age&Gender - DHIS2-SRH.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const locationResponse = await BindAPI("LocationAPI/GetLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) {}
  };

  useEffect(() => {
    const getSelectedServiceSubCategory = async () => {
      const serviceSubCategoryResponse = await BindAPI(
        "ServicesSubCategoryAPI/BindServicesSubCategory"
      );
      setGetServiceSubCDatas(serviceSubCategoryResponse.data.Table);
    };
    // Bind service Dropdown datas
    const getSelectedServices = async () => {
      const serviceSubCategoryResponse = await BindAPI(
        "ServicesMasterAPI/BindServices"
      );
      setGetServicesDatas(serviceSubCategoryResponse.data.Table);
    };

    getSelectedServices();

    getSelectedServiceSubCategory();
  }, []);

  const serviceCategoryDD = async () => {
    try {
      const serviceCategoryResponse = await BindAPI(
        "ServicesCategoryAPI/BindServicesCategory"
      );

      const serviceCategoryData = serviceCategoryResponse.data.Table.map(
        (item) => ({
          value: item.MstServicesCategoryId,
          label: item.ServicesCategory_en,
        })
      );

      setBindServiceCategory(serviceCategoryData);
    } catch (error) {
      // Handle API call errors (e.g., show an error message)
    }
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const ageGenderFieldsChange = (value, name) => {
    setShowTable(false);
    setAgeGenderFields({
      ...ageGenderFields,
      [name]: value,
    });
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      try {
        const getSelectedSDP = async () => {
          const locationResponse = await BindAPI("SDPAPI/GetSDP");
          setGetSDPDatas(locationResponse.data.Table);

          if (userProfileDatas && userProfileDatas[0]) {
            const sdpLabels = locationResponse.data.Table.filter((item) =>
              ageGenderFields.branchProject.includes(
                parseInt(item.MstLocationId)
              )
            ).map((item) => ({
              MstSDPId: item.MstSDPId,
              SDP_en: item.SDP_en,
            }));

            const sdpSelected = sdpLabels.map((SD) => ({
              value: SD.MstSDPId,
              label: SD.SDP_en,
            }));

            if (
              userProfileDatas[0].MstOrganizationId == 1 ||
              userProfileDatas[0].MstOrganizationId == 2
            ) {
              setBindSDP(sdpSelected);
            } else {
              const allSDPIds = userProfileDatas[0]?.AllSDP;
              const sdpId = userProfileDatas[0]?.MstSDPId;
              if (allSDPIds && Array.isArray(allSDPIds)) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  allSDPIds.includes(sdp.value)
                );
                setBindSDP(filteredSdpSelected);
              }
              if (sdpId) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  Array.isArray(sdpId)
                    ? sdpId.includes(sdp.value)
                    : sdpId === sdp.value
                );

                setBindSDP(filteredSdpSelected);
              }
            }
          }
        };

        getSelectedSDP();
      } catch (e) {}
    }
  }, [
    ageGenderFields.branchProject ? ageGenderFields.branchProject : undefined,
    userProfileDatas ? userProfileDatas : undefined,
  ]);

  useEffect(() => {
    if (ageGenderFields.sdp) {
      try {
        const getSelectedArea = async () => {
          const locationResponse = await BindAPI("AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            ageGenderFields.sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) {}
    }
  }, [ageGenderFields.sdp ? ageGenderFields.sdp : undefined]);

  useEffect(() => {
    // Bind Services Sub Category Dropdown datas

    const serviceSubCategorySelectedValue = ageGenderFields.serviceCategory;
    setBindServiceSubCategory([]);
    if (serviceSubCategorySelectedValue) {
      const serviceSubCategoryLabels = getServiceSubCDatas
        .filter((item) =>
          serviceSubCategorySelectedValue.includes(item.MstServicesCategoryId)
        )
        .map((item) => ({
          MstServicesSubCategoryId: item.MstServicesSubCategoryId,
          ServicesSubCategory_en: item.ServicesSubCategory_en,
        }));

      const servicesSubCategorySelected = serviceSubCategoryLabels.map(
        (AR) => ({
          value: AR.MstServicesSubCategoryId,
          label: AR.ServicesSubCategory_en,
        })
      );
      setBindServiceSubCategory(servicesSubCategorySelected);
    } else {
    }
  }, [ageGenderFields.serviceCategory]);

  useEffect(() => {
    // Bind Services Dropdown datas

    const selectedSubCategories = ageGenderFields.serviceSubCategory;
    setBindServicesName([]);
    if (selectedSubCategories.length > 0) {
      const servicesLabels = getServicesData
        .filter((item) =>
          selectedSubCategories.includes(item.MstServicesSubCategoryId)
        )
        .map((item) => ({
          MstServicesId: item.MstServicesId,
          Services_en: item.Services_en,
        }));

      const servicessSelected = servicesLabels.map((AR) => ({
        value: AR.MstServicesId,
        label: AR.Services_en,
      }));
      setBindServicesName(servicessSelected);
    } else {
      // Handle the case when no sub-categories are selected
      setBindServicesName([]);
    }
  }, [ageGenderFields.serviceSubCategory]);

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Age&Gender - SRH`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      ageGenderFields.branchProject?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={ageGenderFields.branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      ageGenderFieldsChange(e, "branchProject");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {ageGenderFieldsError.branchProjectError && (
                    <span className="text-red-500">
                      {ageGenderFieldsError.branchProjectError}
                    </span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                <InputText
                  inputType="text"
                  title="Branch/Project"
                  classStar="text-red-500"
                  name="branchName"
                  disabled="true"
                  content={branchName}
                  controlFunc={(e) => setBranchName(e.target.value)}
                />
              )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.sdp?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="sdp"
                  selectedOptions={ageGenderFields.sdp}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "sdp");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.sdpError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.sdpError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.area?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="area"
                  selectedOptions={ageGenderFields.area}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "area");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.areaError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.areaError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Category"
                  filteredOptions={bindServiceCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceCategory"
                  selectedOptions={ageGenderFields.serviceCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Sub-Category"
                  filteredOptions={bindServiceSubCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceSubCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceSubCategory"
                  selectedOptions={ageGenderFields.serviceSubCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceSubCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceSubCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceSubCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Services"
                  filteredOptions={bindServicesName}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.servicesName?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="servicesName"
                  selectedOptions={ageGenderFields.servicesName}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "servicesName");
                  }}
                />
                {ageGenderFieldsError.servicesNameError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.servicesNameError}
                  </span>
                )}
              </div>
              <AutoDropDown
                title="Project"
                options={bindProjectDD}
                placeholder="Select"
                name="project"
                selectedOption={bindProjectDD.find((x) => x.value == project)}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setProject(value.value);
                }}
              />
            </div>
            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setFromDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setToDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindAgeGenderDHIS2SRHData.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={ageGenderDHIS2SRHReportHeader}
                records={bindAgeGenderDHIS2SRHData}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default AgeGenderDHIS2SRH;
